import store from '@/store'

const usersRoutes = {
    path: 'u/:projectId(\\d+)?',
    name: 'users',
    component: () => import('@/views/Project/ProjectUsers/views/ProjectUsers.vue'),
    meta: {
        title: 'project_menu.people',
        requireProject: true,
    },
}

export default usersRoutes
